/** SO-07 rail icon (eager, tiny): a toon heart in the overlay's ink outline style. */
import type { JSX } from 'preact';

export function HeartIcon({ size = 26 }: { size?: number }): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <path
        d="M16 28s-11-6.6-11-14.2C5 9.4 8 6.5 11.4 6.5c2.1 0 3.7 1.1 4.6 2.7.9-1.6 2.5-2.7 4.6-2.7C24 6.5 27 9.4 27 13.8 27 21.4 16 28 16 28z"
        fill="#ff6b5b"
        stroke="#4a2c2a"
        stroke-width="2.4"
        stroke-linejoin="round"
      />
      <ellipse cx="11" cy="12" rx="2.6" ry="1.6" fill="#fff" opacity=".6" transform="rotate(-30 11 12)" />
    </svg>
  );
}
